import React from "react";
import {buildReviewDetails} from "./qrReviewDetails";

// Per-reason explanation of a draft: bold label, the detail line from reviewNote, muted "What to do".
// Plain component (no hooks): safe in column formatters, modals and the purchase form banner.
export function QrReviewExplanation({reasons, note}) {
    const details = buildReviewDetails(reasons, note);
    if (details.length === 0) {
        return <div className="text-muted">No reason was recorded for this draft. Check the details, then complete or discard.</div>;
    }
    return (
        <ul className="list-unstyled mb-0">
            {details.map((d, idx) => (
                <li key={(d.code || "note") + idx} className={idx > 0 ? "mt-3" : ""}>
                    <div className="fw-bold">{d.label}</div>
                    {d.detail && <div style={{whiteSpace: "pre-line"}}>{d.detail}</div>}
                    {d.hint && <div className="text-muted fs-7"><span className="fw-semibold">What to do:</span> {d.hint}</div>}
                </li>
            ))}
        </ul>
    );
}
